import { Component } from '@theme/component';
import { WishlistStore } from '@theme/wishlist';

const HIDE_DELAY_MS = 4000;

class WishlistToast extends Component {
  requiredRefs = ['label', 'picker', 'pickerMenu'];

  #hideTimer = null;
  #current = null;

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener('wishlist:toast', this.#onAdd);
    document.addEventListener('click', this.#onDocClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('wishlist:toast', this.#onAdd);
    document.removeEventListener('click', this.#onDocClick);
    if (this.#hideTimer) clearTimeout(this.#hideTimer);
  }

  #onAdd = (event) => {
    const detail = event.detail ?? {};
    if (!detail.productId || !detail.listId) return;
    this.#current = detail;

    const title = detail.productTitle || 'Item';
    const listName = detail.listName || 'Wishlist';
    this.refs.label.innerHTML = '';
    const titleEl = document.createElement('span');
    titleEl.className = 'wishlist-toast__title';
    titleEl.textContent = title;
    const suffixEl = document.createElement('span');
    suffixEl.className = 'wishlist-toast__suffix';
    suffixEl.textContent = ` added to ${listName}`;
    this.refs.label.append(titleEl, suffixEl);

    this.#renderPicker();
    this.classList.add('is-visible');

    if (this.#hideTimer) clearTimeout(this.#hideTimer);
    this.#hideTimer = setTimeout(() => this.#hide(), HIDE_DELAY_MS);
  };

  #renderPicker() {
    const detail = this.#current;
    if (!detail) return;
    const lists = WishlistStore.getLists().lists.filter((l) => l.id !== detail.listId);
    if (lists.length === 0) {
      this.refs.picker.classList.add('hidden');
      return;
    }
    this.refs.picker.classList.remove('hidden');
    this.refs.pickerMenu.innerHTML = lists
      .map((l) => `<button class="wishlist-toast__picker-item" data-move-to="${l.id}">${l.name}</button>`)
      .join('');
    this.refs.pickerMenu.querySelectorAll('[data-move-to]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const toListId = btn.dataset.moveTo;
        if (toListId && this.#current) {
          WishlistStore.moveItem(this.#current.productId, this.#current.listId, toListId);
          this.#hide();
        }
      });
    });
  }

  #onDocClick = (e) => {
    if (!this.contains(e.target)) {
      this.refs.pickerMenu.classList.remove('is-open');
    }
  };

  togglePicker(event) {
    event.stopPropagation();
    this.refs.pickerMenu.classList.toggle('is-open');
    // Pause auto-hide while picker is open
    if (this.#hideTimer) {
      clearTimeout(this.#hideTimer);
      this.#hideTimer = null;
    }
  }

  dismiss(event) {
    event.stopPropagation();
    this.#hide();
  }

  #hide() {
    this.classList.remove('is-visible');
    this.refs.pickerMenu.classList.remove('is-open');
    this.#current = null;
    if (this.#hideTimer) {
      clearTimeout(this.#hideTimer);
      this.#hideTimer = null;
    }
  }
}

if (!customElements.get('wishlist-toast')) {
  customElements.define('wishlist-toast', WishlistToast);
}
